import { formatListOptions } from "@/Utils/formatters";
import {
  MobileAppSettings,
  MobileCategoriesViewOptions,
  MobileItemsListViewOptions,
  MobileMenuLayoutOptions
} from "@/config/constant";
const createObj = configModel => {
  const model = {};
  Object.keys(configModel).map(x => (model[x] = null));
  return model;
};

export const models = createObj(MobileAppSettings);

export const options = {
  CategoriesViewOptions: formatListOptions(MobileCategoriesViewOptions),
  ItemsListViewOptions: formatListOptions(MobileItemsListViewOptions),
  MenuLayoutOptions: formatListOptions(MobileMenuLayoutOptions)
};

export const Fields = [
  {
    label: "Mobile App Settings",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Choose Cover Screen",
    name: MobileAppSettings.CoverScreen,
    placeholder: "Upload your amazing cover screen saver",
    type: "file",
    multiple: false,
    value: "",
    xl: "5",
    bodyClasses: "single-image",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Choose Header Background",
    name: MobileAppSettings.HeaderBackground,
    placeholder: "Upload your amazing background",
    type: "file",
    multiple: false,
    value: "",
    xl: "5",
    bodyClasses: "single-image",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Preview Preferences",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Layout View",
    name: MobileAppSettings.MenuLayout,
    placeholder: "",
    type: "select",
    value: "",
    xl: "4",
    options: options.MenuLayoutOptions
  },

  {
    label: "Categories View",
    name: MobileAppSettings.CategoriesView,
    placeholder: "",
    type: "select",
    value: "",
    xl: "4",
    options: options.CategoriesViewOptions
  },
  {
    label: "Items List View",
    name: MobileAppSettings.ItemsListView,
    placeholder: "",
    type: "select",
    value: "",
    xl: "4",
    options: options.ItemsListViewOptions
  },
  {
    label: 'Payment Preferences',
    type: "spacer",
    line: true,
     xl: "12"
  },
  {
    label: "Hide Prices",
    name: MobileAppSettings.HidePrices,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Hide Cart",
    name: MobileAppSettings.HideCart,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Disable Ordering",
    name: MobileAppSettings.DisableOrdering,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Pay Cash",
    name: MobileAppSettings.PayCash,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Pay Online",
    name: MobileAppSettings.PayOnline,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Other Preferences",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Hide Cart",
    name: MobileAppSettings.HideCart,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Random Sorting",
    name: MobileAppSettings.RandomSorting,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Enable Reservations Till",
    name: MobileAppSettings.EnableReservationTill,
    placeholder: "",
    type: "date",
    xl: "3"
  }
];
